import type { BmiResult } from "../types";

export function BmiResultPanel({ result }: { result: BmiResult | null }) {
  if (!result) {
    return (
      <section className="bmi-panel bmi-result-panel empty" aria-live="polite">
        <span>Result</span>
        <strong>Enter your height and weight</strong>
        <p>Your BMI result will be saved in this browser for next time.</p>
      </section>
    );
  }

  return (
    <section className={`bmi-panel bmi-result-panel tone-${result.tone}`} aria-live="polite">
      <div className="bmi-result-heading">
        <span>Your BMI</span>
        <div className="bmi-category">{result.category}</div>
      </div>
      <strong>{result.value.toFixed(1)}</strong>
      <p>{result.message}</p>
      {result.advice ? <p className="bmi-advice">{result.advice}</p> : null}
    </section>
  );
}
